module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/136.ef837ec0.png";